/* import __COLOCATED_TEMPLATE__ from './transition.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { getValue } from '@glimmer/tracking/primitives/cache';
import { assert } from '@ember/debug';
import { invokeHelper } from '@ember/helper';
import { schedule } from '@ember/runloop';
import { modifier } from 'ember-modifier';
import { AppliedClassNamesManager, TransitionVisibilityManager } from '../helpers/transition';
export default class TransitionComponent extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "ownNode", modifier(element => {
      this.ownDomNode = element;
    }));
    _defineProperty(this, "track", modifier(element => {
      this.allTransitionDomNodes.add(element);
      return () => {
        this.allTransitionDomNodes.delete(element);
      };
    }));
    /* === Component Visibility Management === */
    _defineProperty(this, "allTransitionDomNodes", new Set());
    _defineProperty(this, "transitionVisibilityManager", invokeHelper(this, TransitionVisibilityManager, () => ({
      positional: [this.allTransitionDomNodes, this.args.show]
    })));
    /* === Transition Class Name Management === */
    _defineProperty(this, "initialRender", true);
    /** @type {HTMLElement} */
    _defineProperty(this, "ownDomNode", void 0);
    _defineProperty(this, "appliedClassNamesManager", invokeHelper(this, AppliedClassNamesManager, () => ({
      positional: [this, this.args.show]
    })));
    let {
      show
    } = this.args;
    assert(ARG_SHOW_MISSING_ERROR_MESSAGE, typeof show === 'boolean');
    schedule('afterRender', () => {
      this.initialRender = false;
    });
  }
  get tagName() {
    return this.args.tagName ?? 'div';
  }
  get unmount() {
    return this.args.unmount ?? true;
  }
  get componentIsVisible() {
    return getValue(this.transitionVisibilityManager);
  }
  get componentIsMounted() {
    return this.unmount ? this.componentIsVisible : true;
  }
  get componentIsHidden() {
    return this.unmount ? false : !this.componentIsVisible;
  }
  get transitionClassNames() {
    return getValue(this.appliedClassNamesManager);
  }
}
export const ARG_SHOW_MISSING_ERROR_MESSAGE = 'You have to provide a `show` prop to the `Transition` component';